import {useModel} from '@umijs/max';
import BASEURLCONFIG, {BaseRouteUrl} from '../../../../config/BASEURLCONFIG';
import {logout} from "@/services/service";
import ProDescriptions from "@ant-design/pro-descriptions";
import dayjs from "dayjs";
import {purchaseStatusValueEnum} from "@/pages/ISWAN_MES/Constant";
import ProTable from "@ant-design/pro-table";
import React from "react";
import {find as findDictItem} from "@/pages/ISWAN_SET/Dict/DictItem/service";
import DrawPreviewComponent from '@/pages/ISWAN_MES/Mes/Bom/BomDesigner/DrawPreviewComponent';
import styles from "@/global.less";
import {customTableHeaderTitle} from "@/hooks/commonHooks";

export const toSsoLoginPage = async () => {
  let loginUrl = BASEURLCONFIG.sso_login_url;
  location.href = loginUrl;
  console.log("login")
};

export const _logout = async () => {
  await logout();
  let loginUrl = BASEURLCONFIG.sso_login_url + '?redirectUrl=' + location.href;
  console.log(loginUrl);
  location.href = loginUrl;
};

export const getProfileObj = () => {
  let profile = localStorage.getItem('profile');
  console.log({profile});
  return JSON.parse(profile);
};

export const setProfileToLocalStorage = (profile) => {
  localStorage.setItem('profile', profile);
};

export const getCdnScriptUrl = () => {
  return [
    BaseRouteUrl + '/iconfont/iconfont-all.js',
    BaseRouteUrl + '/iconfont/iconfont-menu.js',
  ];
};
export const getColumnsStateMap = (code, childProp) => {
  const {initialState, setInitialState} = useModel('@@initialState');
  return initialState.globalSetting.hideInTableMap &&
  initialState.globalSetting.hideInTableMap[code] &&
  initialState.globalSetting.hideInTableMap[code][childProp]
    ? !initialState.globalSetting.hideInTableMap[code][childProp]['show']
    : false;
};


export const getExtraColumns = (processCode) => {
  let result = [];
  if (processCode) {
    if (processCode.indexOf('ZSCQ_ENTERPRISE_REGISTER_PROCESS') > -1) {
      result = [];
    }
    return result;
  }
};

export const getExtraView = (row, _columnsView, extraData) => {
  let processCode = row.processCode;
  console.log(processCode,'processCode');
  if (!processCode) {
    return null;
  }

  if (processCode === 'MATERIAL_APPLY_PROCESS') {
    let content = JSON.parse(row.content);
    let currentLeftRecord = content.materialRequireSummary;
    let dataSource = content.materialRequires;
    return (
      <>
        <ProDescriptions
          column={4}
          title={"请购单信息"}
        >
          <ProDescriptions.Item label="请购单号">{currentLeftRecord.requireNo}</ProDescriptions.Item>

          <ProDescriptions.Item
            label="创建时间">{currentLeftRecord.createTime ? dayjs(currentLeftRecord.createTime).format('YYYY-MM-DD HH:mm:ss') : null}</ProDescriptions.Item>
          <ProDescriptions.Item
            label="状态">{purchaseStatusValueEnum[currentLeftRecord.submitStatus]?.text}</ProDescriptions.Item>
          <ProDescriptions.Item
            label="提交时间">{currentLeftRecord.submitTime ? dayjs(currentLeftRecord.submitTime).format('YYYY-MM-DD HH:mm:ss') : null}</ProDescriptions.Item>
          <ProDescriptions.Item label="申请人">{currentLeftRecord.createUserNickName}</ProDescriptions.Item>
        </ProDescriptions>
        <ProTable defaultSize={"small"}
                  scroll={{x: 'max-content'}}
                  headerTitle={'数据列表'}
                  rowKey='id'
                  search={false}
                  options={false}
                  dataSource={dataSource}
                  className={styles.custom_fix_padding_0}
                  style={{
                    marginTop:10
                  }}
                  columns={[
                    {
                      title: '序号',
                      hideInSearch: true,
                      align: 'center',
                      width: 50,
                      render: (text, record, index) => `${index + 1}`,
                    },
                    {
                      title: '物料分类',
                      dataIndex: 'category',
                      valueType: 'select',
                      request: async () => {
                        let result = await findDictItem({
                          size: 10000,
                          queryData: {status: 0, code: 'MATERIAL_INFO_CATEGORY', op: '='},
                          sort: 'sortNo asc'
                        });
                        let valueEnum = result.content.map((item) => {
                          return {
                            label: item.label,
                            value: item.value,
                          };
                        });
                        return valueEnum;
                      },
                    },
                    {
                      title: '物料代码',
                      dataIndex: 'rawMaterialNo',
                    },
                    {
                      title: '物料名称',
                      dataIndex: 'rawMaterialName',
                    },
                    {
                      title: '物料规格',
                      dataIndex: 'specs',
                      hideInSearch: true,
                    },
                    {
                      title: '单位',
                      dataIndex: 'unit',
                      hideInSearch: true,
                    },
                    {
                      title: '需求数量',
                      dataIndex: 'requireQty',
                      hideInSearch: true,
                    },
                    {
                      title: '备注',
                      dataIndex: 'remark',
                      width: '150px',
                      hideInSearch: true,
                    }
                  ]}
        />
      </>
    );
  } else if (processCode === 'OUT_PURCHASE_PROCESS') {
    let content = JSON.parse(row.content);
    let currentLeftRecord = content.outPurchaseSummary;
    let dataSource = content.outPurchases;
    return (
      <>
        <ProDescriptions
          column={4}
          title="外协采购单信息"
        >
          <ProDescriptions.Item label="采购单号">{currentLeftRecord.purchaseNo}</ProDescriptions.Item>
          <ProDescriptions.Item
            label="创建时间">{currentLeftRecord.createTime ? dayjs(currentLeftRecord.createTime).format('YYYY-MM-DD HH:mm:ss') : null}</ProDescriptions.Item>
          <ProDescriptions.Item
            label="状态">{purchaseStatusValueEnum[currentLeftRecord.submitStatus]?.text}</ProDescriptions.Item>
          <ProDescriptions.Item
            label="提交时间">{currentLeftRecord.submitTime ? dayjs(currentLeftRecord.submitTime).format('YYYY-MM-DD HH:mm:ss') : null}</ProDescriptions.Item>

          <ProDescriptions.Item label="采购人">{currentLeftRecord.createUserNickName}</ProDescriptions.Item>
          <ProDescriptions.Item label="供应商">{currentLeftRecord.supplierName}</ProDescriptions.Item>

        </ProDescriptions>
        <ProTable defaultSize={"small"}
                  scroll={{x: 'max-content'}}
                  headerTitle={
                    customTableHeaderTitle({
                      title: '数据列表：',
                      partTotal:  dataSource.reduce((acc, item) => {
                        // 检查 total 是否存在且是有效数字
                        if (typeof item.purchaseQty === 'number' && !isNaN(item.purchaseQty)) {
                          return acc + item.purchaseQty;
                        }
                        return acc;
                      }, 0),
                      priceTotal:  dataSource.reduce((acc, item) => {
                        // 检查 total 是否存在且是有效数字
                        if (typeof item.wxTotal === 'number' && !isNaN(item.wxTotal)) {
                          return acc + item.wxTotal;
                        }
                        return acc;
                      }, 0)
                    })}
                  rowKey='id'
                  search={false}
                  options={false}
                  dataSource={dataSource}
                  className={styles.custom_fix_padding_0}
                  style={{
                    marginTop:10
                  }}
                  columns={[
                    {
                      title: '序号',
                      hideInSearch: true,
                      align: 'center',
                      render: (text, record, index) => `${index + 1}`,
                    },
                    {
                      title: '监控号',
                      dataIndex: 'monitorNo',
                      align: 'center'
                    },

                    {
                      title: '项目编号',
                      dataIndex: 'projectNo',
                    },
                    {
                      title: '零件编号',
                      dataIndex: 'materialNo',
                      render: (dom, entity, index) => {
                        return (
                          <DrawPreviewComponent text={entity.materialNo} monitorNo={entity.monitorNo}/>
                        )
                      }
                    },
                    {
                      title: '零件名称',
                      hideInSearch: true,
                      dataIndex: 'materialName',
                    },
                    {
                      title: '零件数量',
                      hideInSearch: true,
                      dataIndex: 'quantity',
                    },
                    {
                      title: '采购数量',
                      hideInSearch: true,
                      dataIndex: 'purchaseQty',
                    },
                    {
                      title: '单价',
                      dataIndex: 'wxPrice',
                      hideInSearch: true,
                    },
                    {
                      title: '总价',
                      dataIndex: 'wxTotal',
                      hideInSearch: true,
                    },
                    {
                      title: '供应商',
                      dataIndex: 'supplierName',
                      hideInSearch: true,
                      render: (_, entity, index) => {
                        return (
                          <span>{entity.supplierName || currentLeftRecord.supplierName}</span>
                        )
                      }
                    },
                    {
                      title: '外协交期',
                      dataIndex: 'wxLeadDate',
                      valueType: 'date',
                      hideInSearch: true,
                    },
                    // {
                    //   title: '是否带料',
                    //   dataIndex: 'haveMaterial',
                    //   valueType: 'select',
                    //   hideInSearch: true,
                    //   valueEnum: {
                    //     0: {
                    //       text: '否',
                    //     },
                    //     1: {
                    //       text: '是',
                    //     },
                    //   },
                    // },
                    {
                      title: '备注',
                      hideInSearch: true,
                      dataIndex: 'remark',
                    },
                  ]}
        />
      </>
    );
  } else if (processCode === 'PURCHASE_PROCESS') {
    let content = JSON.parse(row.content);
    let currentLeftRecord = content.standardPurchaseSummary;
    let dataSource = content.standardPurchases;
    return (
      <>
        <ProDescriptions
          column={4}
          title="物料采购单信息"
        >
          <ProDescriptions.Item label="采购单号">{currentLeftRecord.purchaseNo}</ProDescriptions.Item>
          <ProDescriptions.Item
            label="创建时间">{currentLeftRecord.createTime ? dayjs(currentLeftRecord.createTime).format('YYYY-MM-DD HH:mm:ss') : null}</ProDescriptions.Item>
          <ProDescriptions.Item
            label="状态">{purchaseStatusValueEnum[currentLeftRecord.submitStatus]?.text}</ProDescriptions.Item>
          <ProDescriptions.Item
            label="提交时间">{currentLeftRecord.submitTime ? dayjs(currentLeftRecord.submitTime).format('YYYY-MM-DD HH:mm:ss') : null}</ProDescriptions.Item>
          <ProDescriptions.Item label="采购人">{currentLeftRecord.createUserNickName}</ProDescriptions.Item>
          {
            currentLeftRecord && currentLeftRecord.requireNo && (
              <ProDescriptions.Item label="请购单号">{currentLeftRecord.requireNo}</ProDescriptions.Item>
            )
          }
          <ProDescriptions.Item
            label="供应商">{currentLeftRecord.supplierName || (dataSource.length > 0 ? dataSource[0].supplierName : '')}</ProDescriptions.Item>
        </ProDescriptions>
        <ProTable defaultSize={"small"}
                  scroll={{x: 'max-content'}}
                  headerTitle={
                    customTableHeaderTitle({
                      title: '数据列表：',
                      partTotal:  dataSource.reduce((acc, item) => {
                        // 检查 total 是否存在且是有效数字
                        if (typeof item.purchaseQty === 'number' && !isNaN(item.purchaseQty)) {
                          return acc + item.purchaseQty;
                        }
                        return acc;
                      }, 0),
                      priceTotal:  dataSource.reduce((acc, item) => {
                        // 检查 total 是否存在且是有效数字
                        if (typeof item.total === 'number' && !isNaN(item.total)) {
                          return acc + item.total;
                        }
                        return acc;
                      }, 0)
                    })}
                  rowKey='id'
                  search={false}
                  options={false}
                  dataSource={dataSource}
                  className={styles.custom_fix_padding_0}
                  style={{
                    marginTop:10
                  }}
                  columns={[
                    {
                      title: '序号',
                      hideInSearch: true,
                      align: 'center',
                      width: 50,
                      render: (text, record, index) => `${index + 1}`,
                    },
                    {
                      title: '物料分类',
                      dataIndex: 'category',
                      valueType: 'select',
                      request: async () => {
                        let result = await findDictItem({
                          size: 10000,
                          queryData: {status: 0, code: 'MATERIAL_INFO_CATEGORY', op: '='},
                          sort: 'sortNo asc'
                        });
                        let valueEnum = result.content.map((item) => {
                          return {
                            label: item.label,
                            value: item.value,
                          };
                        });
                        return valueEnum;
                      },
                    },
                    {
                      title: '物料代码',
                      dataIndex: 'rawMaterialNo',
                    },
                    {
                      title: '物料名称',
                      dataIndex: 'rawMaterialName',
                    },
                    {
                      title: '物料规格',
                      dataIndex: 'specs',
                      hideInSearch: true,
                    },
                    {
                      title: '单位',
                      dataIndex: 'unit',
                      hideInSearch: true,
                    },
                    {
                      title: '需求数量',
                      dataIndex: 'requireQty',
                      hideInTable: currentLeftRecord && !currentLeftRecord.requireNo,
                      hideInSearch: true,
                    },
                    {
                      title: '需求备注',
                      dataIndex: 'requireRemark',
                      hideInTable: currentLeftRecord && !currentLeftRecord.requireNo,
                      hideInSearch: true,
                    },
                    {
                      title: '采购数量',
                      hideInSearch: true,
                      dataIndex: 'purchaseQty',
                    },
                    {
                      title: '单价',
                      hideInSearch: true,
                      dataIndex: 'price',
                    },
                    {
                      title: '总价',
                      hideInSearch: true,
                      dataIndex: 'total',
                    },
                    {
                      title: '供应商名称',
                      hideInSearch: true,
                      dataIndex: 'supplierName',
                      render: (_, entity, index) => {
                        return (
                          <span>{entity.supplierName || currentLeftRecord.supplierName}</span>
                        )
                      }
                    },
                    {
                      title: '交期',
                      hideInSearch: true,
                      dataIndex: 'leadDate',
                      valueType: 'date',
                    },
                    {
                      title: '备注',
                      hideInSearch: true,
                      dataIndex: 'remark',
                    },
                  ]}
        />
      </>
    );
  } else if (processCode === 'MATERIAL_PURCHASE_REFUND_PROCESS') {
    let content = JSON.parse(row.content);
    let currentLeftRecord = content.materialPurchaseRefundSummary;
    let dataSource = content.materialPurchaseRefunds;
    return (
      <>
        <ProDescriptions
          column={4}
          title="采购退货单信息"
        >
          <ProDescriptions.Item label="采购退货单号">{currentLeftRecord.refundNo}</ProDescriptions.Item>
          <ProDescriptions.Item
            label="创建时间">{currentLeftRecord.createTime ? dayjs(currentLeftRecord.createTime).format('YYYY-MM-DD HH:mm:ss') : null}</ProDescriptions.Item>
          <ProDescriptions.Item
            label="状态">{purchaseStatusValueEnum[currentLeftRecord.submitStatus]?.text}</ProDescriptions.Item>
          <ProDescriptions.Item
            label="提交时间">{currentLeftRecord.submitTime ? dayjs(currentLeftRecord.submitTime).format('YYYY-MM-DD HH:mm:ss') : null}</ProDescriptions.Item>
          <ProDescriptions.Item label="采购人">{currentLeftRecord.createUserNickName}</ProDescriptions.Item>
          <ProDescriptions.Item label="采购单号">{currentLeftRecord.purchaseNo}</ProDescriptions.Item>
          <ProDescriptions.Item
            label="供应商">{currentLeftRecord.supplierName || (dataSource.length > 0 ? dataSource[0].supplierName : '')}</ProDescriptions.Item>
        </ProDescriptions>
        <ProTable defaultSize={"small"}
                  scroll={{x: 'max-content'}}
                  headerTitle={'数据列表'}
                  rowKey='id'
                  search={false}
                  options={false}
                  dataSource={dataSource}
                  className={styles.custom_fix_padding_0}
                  style={{
                    marginTop:10
                  }}
                  columns={[
                    {
                      title: '序号',
                      hideInSearch: true,
                      align: 'center',
                      width: 50,
                      render: (text, record, index) => `${index + 1}`,
                    },
                    {
                      title: '物料代码',
                      dataIndex: 'rawMaterialNo',
                    },
                    {
                      title: '物料名称',
                      dataIndex: 'rawMaterialName',
                    },
                    {
                      title: '供应商名称',
                      hideInSearch: true,
                      dataIndex: 'supplierName',
                      render: (_, entity, index) => {
                        return (
                          <span>{entity.supplierName || currentLeftRecord.supplierName}</span>
                        )
                      }
                    },
                    {
                      title: '采购数量',
                      hideInSearch: true,
                      dataIndex: 'purchaseQty',
                    },
                    {
                      title: '退货数量',
                      dataIndex: 'refundQty',
                      hideInSearch: true,
                    },
                    {
                      title: '退货备注',
                      dataIndex: 'materialPurchaseRefundRemark',
                      hideInSearch: true,
                    }
                  ]}
        />
      </>
    );
  }
  return null;
};
export const getBaseUrlByProcessCode = (processCode) => {
  return BASEURLCONFIG.ISWAN_MES_URL;
};

